export default __webpack_public_path__ + "static/media/project_1_pic.e171ae27.png";